import { render, staticRenderFns } from "./TeamMemberPaginator.vue?vue&type=template&id=7bb66597&"
import script from "./TeamMemberPaginator.vue?vue&type=script&lang=js&"
export * from "./TeamMemberPaginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports